module.exports = __webpack_public_path__ + "static/img/chenzhong_top.476fd7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/chenzhong_top.png
// module id = xjWy
// module chunks = 4